// 画面の新しい版が公開されているかを確認する
// 公開前から開いていたタブは古いコードのまま動き続けるため、ログイン画面やログイン直後に確認して読み込み直す。
// （本番ビルドの index.html が読み込む main.<ハッシュ>.js を比べる。開発サーバーでは常に false）
const MAIN_SCRIPT_PATTERN = /\/static\/js\/main\.[0-9a-f]+\.js/;

export async function isNewVersionAvailable() {
  try {
    const current = Array.from(document.scripts)
      .map((s) => s.getAttribute('src') || '')
      .find((src) => MAIN_SCRIPT_PATTERN.test(src));
    if (!current) return false;
    const res = await fetch(`/index.html?v=${Date.now()}`, { cache: 'no-store' });
    if (!res.ok) return false;
    const latest = (await res.text()).match(MAIN_SCRIPT_PATTERN)?.[0];
    return !!latest && !current.includes(latest);
  } catch {
    return false;
  }
}
